"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasKey = void 0;
function hasKey(subject, ...keys) {
    return !keys.some(key => !subject[key]);
}
exports.hasKey = hasKey;
//# sourceMappingURL=hasKey.js.map